import { TableItemTitle } from "./calculateTitleList";

export const YEAR_TOTAL_COLUMN = (data) => [
  {
    title: <TableItemTitle title="Calculate.Gas" />,
    dataIndex: "GasName",
    key: "GasName",
    fixed: "left",
  },
  {
    title: <TableItemTitle title="Calculate.GasFactor" />,
    dataIndex: "GasParameter",
    key: "GasParameter",
  },
  {
    title: <TableItemTitle title="Calculate.HeatValue" />, // "熱值",
    dataIndex: "HeatValue",
    key: "HeatValue",
    render: (text, record, index) => {
      return index === 0
        ? {
            children: text || "0",
            props: {
              rowSpan: data.length,
            },
          }
        : {
            props: {
              rowSpan: 0,
            },
          };
    },
  },
  {
    title: <TableItemTitle title="Calculate.ParaFactor" />,
    dataIndex: "Parameter",
    key: "Parameter",
  },
  {
    title: <TableItemTitle title="Process.Scalar_B" />,
    dataIndex: "Scalar",
    key: "Scalar",
    render: (text, record, index) => {
      return index === 0
        ? {
            children: text || "",
            props: {
              rowSpan: data.length,
            },
          }
        : {
            props: {
              rowSpan: 0,
            },
          };
    },
  },
  {
    title: (
      <>
        <TableItemTitle title="Process.Scalar_B" />
        x <TableItemTitle title="Calculate.ParaFactor" />
      </>
    ),
    dataIndex: "Subtotal",
    key: "Subtotal",
  },
  {
    title: "GWP",
    dataIndex: "GWP",
    key: "GWP",
  },
  {
    title: (
      <>
        <TableItemTitle title="Sbti.Emission" /> KgCO2e
      </>
    ),
    dataIndex: "GasKgCO2e",
    key: "GasKgCO2e",
  },
  {
    title: (
      <>
        <TableItemTitle title="Calculate.Total_B" /> KgCO2e
      </>
    ),
    dataIndex: "Total",
    key: "Total",
    render: (text, record, index) => {
      return index === 0
        ? {
            children: text || "",
            props: {
              rowSpan: data.length,
            },
          }
        : {
            props: {
              rowSpan: 0,
            },
          };
    },
  },
];

export const WORKHOUR_TOTAL_COLUMN = (data) => [
  {
    title: <TableItemTitle title="Calculate.TotalWorkHour" />,
    dataIndex: "ScalarString",
    key: "ScalarString",
  },
  {
    title: <TableItemTitle title="Calculate.WorkHour.Total.Title.Para" />,
    dataIndex: "Factor",
    key: "Factor",
  },
  {
    title: <TableItemTitle title="Calculate.WorkHour.Total.Title.Total" />,
    dataIndex: "SubTotal",
    key: "SubTotal",
  },
  {
    title: "GWP",
    dataIndex: "GWP",
    key: "GWP",
  },
  {
    title: <TableItemTitle title="Calculate.WorkHour.Total.Title.Emission" />,
    dataIndex: "KgCO2e",
    key: "KgCO2e",
  },
];

export const REFRIGERANR_TOTAL_COLUMN = (data) => [
  {
    title: <TableItemTitle title="Refrigerant.Scalar_B" />,
    dataIndex: "ScalarString",
    key: "ScalarString",
  },
  {
    title: (
      <>
        <TableItemTitle title="CompanyPara.Coefficient" />
        (<TableItemTitle title="Refrigerant.factor" />)
      </>
    ),
    dataIndex: "Factor",
    key: "Factor",
  },
  {
    title: <TableItemTitle title="Refrigerant.UsedMonth" />,
    dataIndex: "UsedMonth",
    key: "UsedMonth",
  },
  {
    title: (
      <>
        <TableItemTitle title="Refrigerant.Scalar_B" /> X
        <TableItemTitle title="CompanyPara.Coefficient" />
        (<TableItemTitle title="Refrigerant.factor" />) X
        <TableItemTitle title="Calculate.Refrigerant.Total.Column" />
      </>
    ),
    dataIndex: "SubTotal",
    key: "SubTotal",
  },

  {
    title: "GWP",
    dataIndex: "GWP",
    key: "GWP",
  },
  {
    title: <TableItemTitle title="Calculate.WorkHour.Total.Title.Emission" />,
    dataIndex: "KgCO2e",
    key: "KgCO2e",
  },
];

export const FIREEQUIPMENT_TOTAL_COLUMN = (data) => [
  {
    title: <TableItemTitle title="FireEquipment.Scalar" />,
    dataIndex: "ScalarString",
    key: "ScalarString",
  },
  {
    title: "GWP",
    dataIndex: "GWP",
    key: "GWP",
  },
  {
    title: <TableItemTitle title="Calculate.WorkHour.Total.Title.Emission" />,
    dataIndex: "KgCO2e",
    key: "KgCO2e",
  },
];

export const OTHERCOMPOUND_TOTAL_COLUMN = (data) => [
  {
    title: <TableItemTitle title="OtherCompounds.Scalar" />,
    dataIndex: "ScalarString",
    key: "ScalarString",
  },
  {
    title: <TableItemTitle title="Calculate.Para" />,
    dataIndex: "Factor",
    key: "Factor",
  },
  {
    title: (
      <>
        <TableItemTitle title="OtherCompounds.Scalar" /> X
        <TableItemTitle title="Calculate.Para" />
      </>
    ),
    dataIndex: "SubTotal",
    key: "SubTotal",
  },
  {
    title: "GWP",
    dataIndex: "GWP",
    key: "GWP",
  },
  {
    title: <TableItemTitle title="Calculate.WorkHour.Total.Title.Emission" />,
    dataIndex: "KgCO2e",
    key: "KgCO2e",
  },
];

export const POWERUSAGE_TOTAL_COLUMN = (data) => [
  {
    title: <TableItemTitle title="PowerUsages.Scalar" />,
    dataIndex: "Scalar",
    key: "Scalar",
  },
  {
    title: <TableItemTitle title="Calculate.Para" />,
    dataIndex: "Factor",
    key: "Factor",
  },
  {
    title: <TableItemTitle title="Calculate.WorkHour.Total.Title.Emission" />,
    dataIndex: "KgCO2e",
    key: "KgCO2e",
  },
];

export const STEAMUSAGE_TOTAL_COLUMN = (data) => [
  {
    title: <TableItemTitle title="SteamUsages.Scalar" />,
    dataIndex: "Scalar",
    key: "Scalar",
  },
  {
    title: <TableItemTitle title="Calculate.Para" />,
    dataIndex: "Factor",
    key: "Factor",
  },
  {
    title: <TableItemTitle title="Calculate.WorkHour.Total.Title.Emission" />,
    dataIndex: "KgCO2e",
    key: "KgCO2e",
  },
];

export const LIFECYCLE_TOTAL_COLUMN = (data) => [
  {
    title: <TableItemTitle title="LifeCycle.Scalar" />,
    dataIndex: "Scalar",
    key: "Scalar",
  },
  {
    title: <TableItemTitle title="Calculate.Para" />,
    dataIndex: "Factor",
    key: "Factor",
  },
  {
    title: <TableItemTitle title="Calculate.WorkHour.Total.Title.Emission" />,
    dataIndex: "KgCO2e",
    key: "KgCO2e",
  },
];
